import React, { useEffect, useState } from "react";
import axios from "axios";

import { GET_ISSUER_REQUESTED_PRODUCTS, ACKNOWLEDGE_ISSUER_REQUESTED_PRODUCTS, APP_BASE_URL } from "../../AppConstant";
import { red } from "@mui/material/colors";

import LoadingGif from "../../../assets/images/Spin_loader.gif"

function IssuerRequestedProductsPage({setParentLoading}) {
    const [requestedProducts, setRequestedProducts] = useState([]);

    const Requestedproducts = async () => {

        try {
             setParentLoading(true);
            const emailid = localStorage.getItem("emailid");

            console.log("EMAIL:", emailid);

            const res = await axios.get(GET_ISSUER_REQUESTED_PRODUCTS, {
                params: { "itissuer": emailid }
            });
            setRequestedProducts(res.data);
            console.log("API response:", res.data);
             setTimeout(() => {
            setParentLoading(false);
        }, 500);
        } catch (err) {
            console.error(err);
             setTimeout(() => {
            setParentLoading(false);
        }, 500);
        }
    };

    const IssuerAcknowledge = async (id, productid, empid, puuid) =>{
        try {
             setParentLoading(true);
            const emailid = localStorage.getItem("emailid");

             await axios.post(ACKNOWLEDGE_ISSUER_REQUESTED_PRODUCTS, {
                id: id,
                productid: productid,
                itissuer: emailid,
                empid : empid,
                puuid : puuid
            });

            Requestedproducts();
             setTimeout(() => {
            setParentLoading(false);
        }, 500);
            
        } catch (error) {
            console.log(error)
             setTimeout(() => {
            setParentLoading(false);
        }, 500);
        }

    }

    

    useEffect(() => {
        Requestedproducts();
    }, []);

    const generateRequestId = (item) => {
        const date = new Date(item.requested_at);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");

        const paddedId = String(item.id).padStart(4, "0");

        return `ACC-${year}${month}-${paddedId}`;
    };



   const generateStage = (item) => {

        const normalize = (val) =>
            val === null || val === undefined || val === ""
                ? null
                : val.toString().trim().toLowerCase();

        const FH = normalize(item.functional_status);
        const IT = normalize(item.it_status);
        const issued = item.issued;
         const acknowledge = item.status;

    if(acknowledge === "A"){
        return "Pending with Ackwnowledge"
    }

        if (!FH) {
            return "Pending with Reporting Manager";
        }

        if (FH === "rejected") {
            return "Rejected (Reporting Manager)";
        }

        if (FH === "approved" && !IT) {
            return "Pending with IT Admin";
        }

        if (IT === "rejected") {
            return "Rejected (IT Admin)";
        }

        if (FH === "approved" && IT === "approved" && !issued) {
            return "Pending with IT Issuer";
        }

        if (issued === true) {
            return "ISSUED";
        }

        return "Unknown";
    };

     const [searchTerm, setSearchTerm] = useState("");
            
                const filteredProducts = requestedProducts.filter((item) => {
                const searchableText = [
                    ...Object.values(item),
                    generateRequestId(item),
                    generateStage(item)
                ]
                    .join(" ")
                    .toLowerCase();
            
                return searchableText.includes(searchTerm.toLowerCase());
            });

    return (
        <div>
           <div className="input-group mb-3" style={{ width: "500px" }}>
    <span className="input-group-text">
        <i className="bi bi-search"></i>
    </span>

    <input
        type="text"
        className="form-control"
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
</div>
            <table className="mt-3 fw-bold" style={{ fontSize: "small" }}>
                <thead className="bg-primary" style={{color:"var(--bs-white)"}} >
                    <tr>
                        <th>S.No</th>
                        <th>REQUEST ID</th>
                        <th>EMPLOYEE ID</th>
                        <th>EMPLOYEE NAME</th>
                        <th>EMPLOYEE EMAIL</th>
                        <th>IT HEAD</th>
                        <th>PRODUCT NAME </th>
                        <th>STATUS</th>
                        <th>STAGE</th>
                        <th>ACTION</th>
                        <th>LAST UPDATE</th>
                    </tr>
                </thead>

                <tbody  className="text-secondary" style={{fontSize:"small"}}>
                    {filteredProducts.length > 0 ? (
                        filteredProducts.map((item, index) => (
                            <tr key={item.id}>

                                <td>{index + 1}</td>
                                <td>{generateRequestId(item)}</td>
                                <td>{item.employee_id}</td>
                                <td>{item.employee_name}</td>
                                <td>{item.employee_email}</td>
                              <td>{item.ithead?.split("@")[0]?.toUpperCase() || ""}</td>

                                <td>{item.product_name}</td>



                                <td >
                                    <span
                                        className={`status-text ${item.status === "T"
                                                ? "status-pending"
                                                : item.status === "F"
                                                    ? "status-rejected"
                                                    : item.status === "A"
                                                    ? "status-acknowledge"
                                                    : item.status === "I"
                                                        ? "status-issued"
                                                        : "status-unknown"
                                            }`}
                                    >
                                        {item.status === "T"
                                            ? "Pending"
                                            : item.status === "F"
                                                ? "Rejected"
                                                 : item.status === "A"
                                                ? "Acknowledgement Sent"
                                                : item.status === "I"
                                                    ? "Issued"
                                                    : "Unknown"}
                                    </span>
                                </td>

                                <td >{generateStage(item)}</td>

                                <td>
                                    { item.issued ?  (
                                       
<span style={{ color: "green", fontWeight: "bold" }}>
           COMPLETED
        </span>
                                    )
                                    :item.status ==="A"  ?  (
                                       
<span style={{ color: "blue", fontWeight: "bold" }}>
            Acknowledgement Sent
        </span>

                                    ) :
                                    (
                                        <div className="d-flex justify-content-center">
                                            <p
                                                className="m-0 btn btn-success btn-sm"
                                                style={{ fontWeight: "bold", fontSize: "10px" }}
                                                onClick={()=>IssuerAcknowledge(item.id, item.product_id, item.employee_id, item.puuid)}
                                            >
                                                DELIVER
                                            </p>

                                           
                                        </div>
                                    )}
                                </td>

                                 <td>
  {new Date(item.lastupdatedat.replace(" ", "T"))
    .toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    })
    .replace(",", "")}
</td>

                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                                No products available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default IssuerRequestedProductsPage;